import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TestHooks } from './section.hooks';

@Component({
	selector: 'app-create-section',
	templateUrl: './section.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class SectionComponent {
	testHooks = TestHooks;
	@Input() class: string;
	@Input() title: string;
}
